export namespace DefaultTexts {
    export const semTitulo = '(sem título)';
}
